<div class="radio-section" (click)="radioTouched(radioId)">
    <div [id]="radioLabel" class="radio" [class.selected]="selected"></div>
    <label [for]="radioLabel">{{ radioLabel }}</label>
</div>